'use client';

import { useState, useEffect } from 'react';
import { Settings, X, RefreshCw } from 'lucide-react';
import { getCurrentTenantContext, clearDevSchool } from '@/utils/tenantResolver';

export default function DevModeBadge() {
    const [isExpanded, setIsExpanded] = useState(false);
    const [tenantContext, setTenantContext] = useState(null);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
        setTenantContext(getCurrentTenantContext());
    }, []);

    // Only render on client-side after mount
    if (!isMounted) {
        return null;
    }

    // Only show in development environment + when mode is 'development'
    if (process.env.NODE_ENV !== 'development' || tenantContext?.mode !== 'development' || !tenantContext?.identifier) {
        return null;
    }

    return (
        <div className="fixed bottom-4 right-4 z-50">
            {isExpanded ? (
                <div className="bg-gradient-to-br from-amber-500 to-orange-600 text-white rounded-2xl shadow-2xl p-4 min-w-[280px] animate-in fade-in zoom-in duration-200">
                    <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-2">
                            <Settings size={18} className="animate-spin-slow" />
                            <span className="font-bold text-sm">Development Mode</span>
                        </div>
                        <button
                            onClick={() => setIsExpanded(false)}
                            className="hover:bg-white/20 rounded-lg p-1 transition"
                        >
                            <X size={16} />
                        </button>
                    </div>

                    <div className="space-y-2 text-sm">
                        <div className="bg-white/10 rounded-lg p-2">
                            <div className="text-xs opacity-75 mb-1">Current School</div>
                            <div className="font-mono font-bold">{tenantContext.identifier}</div>
                        </div>

                        <div className="bg-white/10 rounded-lg p-2">
                            <div className="text-xs opacity-75 mb-1">Source</div>
                            <div className="font-medium capitalize">{tenantContext.source}</div>
                        </div>

                        <button
                            onClick={clearDevSchool}
                            className="w-full bg-white/20 hover:bg-white/30 rounded-lg p-2 flex items-center justify-center gap-2 transition font-medium text-sm"
                        >
                            <RefreshCw size={14} />
                            Switch School
                        </button>
                    </div>

                    <div className="mt-3 pt-3 border-t border-white/20 text-xs opacity-75">
                        💡 Use <code className="bg-black/20 px-1 py-0.5 rounded">?school=CODE</code> to switch
                    </div>
                </div>
            ) : (
                <button
                    onClick={() => setIsExpanded(true)}
                    className="bg-gradient-to-br from-amber-500 to-orange-600 text-white rounded-full shadow-lg hover:shadow-xl p-3 flex items-center gap-2 transition-all hover:scale-105 active:scale-95"
                >
                    <Settings size={18} className="animate-spin-slow" />
                    <span className="font-bold text-sm pr-1">DEV</span>
                </button>
            )}
        </div>
    );
}
